import PropTypes from 'prop-types'
import { createTypeElement, createPropTypes } from './util'

const SubHeader = props => createTypeElement('SubHeader', props)
SubHeader.propTypes = createPropTypes({
  size: PropTypes.oneOf(['large', 'small', 'tiny']),
})

export default SubHeader
